<template>
  <div>
    Meal Ingredient Picker
  </div>
</template>

<script>
export default {
  name: 'MealDetailView'
}
</script>

<style lang="scss">

</style>
